const karinLawRoutes = props => {
  return {
    defaultRequestParams: {},
    showRoutePath: Routes.karin_law_workflow_requirement_path,
    indexRoutePath: Routes.karin_law_workflow_requirements_path,
    newRoutePath: Routes.new_karin_law_workflow_requirement_path,
    createRoutePath: Routes.karin_law_workflow_requirements_path,
  }
}

const karinLawPublicRoutes = props => {
  return {
    defaultRequestParams: {
      customer_id: props?.currentCustomer?.hashid,
      process_id: props?.requirement?.process.hashid
    },
    showRoutePath: Routes.created_public_karin_law_workflow_requirement_path,
    // indexRoutePath: null,
    // newRoutePath: null,
    createRoutePath: Routes.public_karin_law_workflow_requirements_path
  }
}

const karinLawPortalRoutes = props => {
  return {
    defaultRequestParams: {
      tenant: props?.currentCustomer?.portal_configuration?.tenant,
      process_id: props?.requirement.process_id
    },
    showRoutePath: Routes.portal_karin_law_workflow_requirement_path,
    indexRoutePath: Routes.portal_karin_law_workflow_requirements_path,
    newRoutePath: Routes.new_portal_karin_law_workflow_requirement_path,
    createRoutePath: Routes.portal_karin_law_workflow_requirements_path,
  }
}

const abstractRoutes = props => {
  return {
    defaultRequestParams: { current_entity_type_id: props?.currentEntityType?.hashid },
    showRoutePath: Routes.abstract_workflow_requirement_path,
    indexRoutePath: Routes.abstract_workflow_requirements_path,
    newRoutePath: '',
    createRoutePath: Routes.abstract_workflow_requirements_path,
  }
}

const abstractPublicRoutes = props => {
  return {
    defaultRequestParams: {
      customer_id: props?.currentCustomer?.hashid,
      process_id: props?.requirement?.process.hashid
    },
    showRoutePath: Routes.created_public_abstract_workflow_requirement_path,
    // indexRoutePath: '',
    // newRoutePath: '',
    createRoutePath: Routes.public_abstract_workflow_requirements_path,
  }
}

const abstractPortalRoutes = props => {
  return {
    defaultRequestParams: {
      tenant: props?.currentCustomer?.portal_configuration?.tenant,
      process_id: props?.requirement.process_id
    },
    showRoutePath: Routes.portal_abstract_workflow_requirement_path,
    indexRoutePath: Routes.portal_abstract_workflow_requirements_path,
    newRoutePath: Routes.new_portal_abstract_workflow_requirement_path,
    createRoutePath: Routes.portal_abstract_workflow_requirements_path,
  }
}

const economicCrimeRoutes = props => {
  return {
    defaultRequestParams: {},
    showRoutePath: Routes.economic_crime_workflow_requirement_path,
    indexRoutePath: Routes.economic_crime_workflow_requirements_path,
    newRoutePath: Routes.new_economic_crime_workflow_requirement_path,
    createRoutePath: Routes.economic_crime_workflow_requirements_path,
  }
}

const economicCrimePublicRoutes = props => {
  return {
    defaultRequestParams: {
      customer_id: props?.currentCustomer?.hashid,
      process_id: props?.requirement?.process.hashid
    },
    showRoutePath: Routes.created_public_economic_crime_workflow_requirement_path,
    // indexRoutePath: null,
    // newRoutePath: null,
    createRoutePath: Routes.public_economic_crime_workflow_requirements_path
  }
}

const economicCrimePortalRoutes = props => {
  return {
    defaultRequestParams: {
      tenant: props?.currentCustomer?.portal_configuration?.tenant,
      process_id: props?.requirement.process_id
    },
    showRoutePath: Routes.portal_economic_crime_workflow_requirement_path,
    indexRoutePath: Routes.portal_economic_crime_workflow_requirements_path,
    newRoutePath: Routes.new_portal_economic_crime_workflow_requirement_path,
    createRoutePath: Routes.portal_economic_crime_workflow_requirements_path,
  }
}

const laboralRoutes = props => {
  return {
    defaultRequestParams: {},
    showRoutePath: Routes.laboral_workflow_requirement_path,
    indexRoutePath: Routes.laboral_workflow_requirements_path,
    newRoutePath: '',
    createRoutePath: Routes.laboral_workflow_requirements_path,
  }
}

const laboralPublicRoutes = props => {
  return {
    defaultRequestParams: {
      customer_id: props?.currentCustomer?.hashid,
      process_id: props?.requirement?.process.hashid
    },
    showRoutePath: Routes.created_public_laboral_workflow_requirement_path,
    // indexRoutePath: '',
    // newRoutePath: '',
    createRoutePath: Routes.public_laboral_workflow_requirements_path,
  }
}

const laboralPortalRoutes = props => {
  return {
    defaultRequestParams: {
      tenant: props?.currentCustomer?.portal_configuration?.tenant,
      process_id: props?.requirement.process_id
    },
    showRoutePath: Routes.portal_laboral_workflow_requirement_path,
    indexRoutePath: Routes.portal_laboral_workflow_requirements_path,
    newRoutePath: Routes.new_portal_laboral_workflow_requirement_path,
    createRoutePath: Routes.portal_laboral_workflow_requirements_path,
  }
}

// Function lookup object
const routeFunctions = {
  karin_law: {
    default: karinLawRoutes,
    public: karinLawPublicRoutes,
    portal: karinLawPortalRoutes
  },
  economic_crime: {
    default: economicCrimeRoutes,
    public: economicCrimePublicRoutes,
    portal: economicCrimePortalRoutes
  },
  abstract: {
    default: abstractRoutes,
    public: abstractPublicRoutes,
    portal: abstractPortalRoutes
  },
  laboral: {
    default: laboralRoutes,
    public: laboralPublicRoutes,
    portal: laboralPortalRoutes
  }
}

export const workflowRequirementRoutesForm = props => {
  const context = props?.configuration?.context || 'default';

  let moduleType = '';

  switch (props?.requirement?.module_type) {
    case 'KarinLaw::Workflow::Requirement':
      moduleType = 'karin_law'; break;
    case 'EconomicCrime::Workflow::Requirement':
      moduleType = 'economic_crime'; break;
    case 'Abstract::Workflow::Requirement':
      moduleType = 'abstract'; break;
    case 'Laboral::Workflow::Requirement':
      moduleType = 'laboral'; break;
    default:
      moduleType = 'abstract'; // default fallback
  }

  const routeFunction = routeFunctions[moduleType]?.[context] || routeFunctions[moduleType]?.default;

  const options = routeFunction(props);

  return {
    configuration: {
      defaultRequestParams: options.defaultRequestParams
    },
    routes: {
      createRoutePath: options.createRoutePath,
      indexRoutePath: options.indexRoutePath,
      newRoutePath: options.newRoutePath,
      showRoutePath: options.showRoutePath
    }
  }
}
